import React, { useState } from 'react';
import { array } from 'prop-types';

import { connect } from 'react-redux';

import { capitalize, isEmpty  } from 'lodash';

import MaterialTable from 'material-table';

import ConfigureSensorModal from '../../Modals/ConfigureSensorModal';
import MapObjectToSensorTableRowMenu from './MapObjectToSensorTableRowMenu';

import * as WizardActions from '../../../actions/wizardActions';

import classes from './ProfileTable.module.css';

const MapObjectToSensorTable = ({
    removeTargetSensor,
    targetProfileObjects,
    ...props
}) => {

    const [configureSensorModalOpen, setConfigureSensorModalOpen] = useState(false);
    const [object, setObject] = useState({});

    // Define columns prior to injecting them into component's state
    const columns = [
        { title: 'Object Name', field: 'name' },
        { 
            title: 'Sensor Type',
            field: 'sensorTypeName'
        },
        { title: 'Profile', field: 'profileName' },
        { title: 'Object Type', field: 'objectType' },
        {
            title:  'Data Type',
            field:  'dataType',
            render: rowData => !isEmpty(rowData.dataType) ? capitalize(rowData.dataType) : ''
        },
        { 
            title: 'Display Unit',
            field: 'displayUnitName'
        },
        {
            title:      'Configured',
            render:     rowData => rowData.isConfigured ? <img src="/assets/images/billing-ok.svg" alt="checkmark" /> : null,
            customSort: (a, b) => b.isConfigured - a.isConfigured
        },
        {
            title:  '',
            render: rowData => renderMenu(rowData)
        }
    ];

    // This is a WORK AROUND for a Material Table (as of v1.68) issue where column sort state was lost when parent
    // component's state updates. This technique is not meant for global adoption; check on the current
    // state of Material Table & determine if a solution has been introduced before copy/pasting this code.
    // That said, lifting the columns into the parent's state preserves it and prevents state change from
    // "dropping" the current column sort order.
    //
    // https://github.com/mbrn/material-table/issues/1265
    const [tableColumns] = useState(columns);

    const renderMenu = rowData => {
        return (
            <MapObjectToSensorTableRowMenu
                clearSensor={clearSensor}
                object={rowData}
                setObject={setObject}
                onConfigureSensorModal={setConfigureSensorModalOpen}
            />
        );
    };

    const clearSensor = object => {
        if (isEmpty(object)) return;

        removeTargetSensor(object);
    };
    
    return (
        <div className={classes.ProfileTable}>
            <div className={classes.title}>
                <h2>Available Objects</h2>
            </div>
            <div className={classes.tableContainer}>
                <MaterialTable
                    options={{
                        paging:    false,
                        showTitle: false,
                        search:    false,
                        selection: false,
                        toolbar:   false,
                        filtering: true
                    }}
                    columns={tableColumns}
                    data={targetProfileObjects}
                />
            </div>
            <ConfigureSensorModal
                open={configureSensorModalOpen}
                close={() => setConfigureSensorModalOpen(false)}
                object={object}
                title="Configure Sensor"
            />
        </div>
    );
};

MapObjectToSensorTable.defaultProps = {
    targetProfileObjects: []
};

MapObjectToSensorTable.propTypes = {
    targetProfileObjects: array
};

const mapStateToProps = state => {
    return {
        targetProfileObjects: state.wizard.targetProfileObjects
    };
};

const mapDispatchToProps = {
    ...WizardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(MapObjectToSensorTable);
